import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrapeResponseData, DEFAULT_KEY_PRICE, DEFAULT_MARKUP_PERCENT } from '../../../../shared/pricing.types';
import { parsePrice } from '../../../../shared/pricing.utils';

@Component({
  selector: 'app-scrape-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scrape-panel.component.html',
  styleUrl: './scrape-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrapePanelComponent {
  readonly data = input.required<ScrapeResponseData>();
  readonly apply = output<number>();

  readonly priceInKeys = signal<number>(0);
  readonly markupPercent = signal<number>(DEFAULT_MARKUP_PERCENT);
  readonly keyPrice = signal<number>(DEFAULT_KEY_PRICE);

  readonly suggestedPrice = computed(() => {
    const p = this.priceInKeys();
    const k = this.keyPrice();
    const m = this.markupPercent();
    return p * k * (1 + m / 100);
  });

  constructor() {
    effect(() => {
      const d = this.data();
      this.priceInKeys.set(parsePrice(d.price));
    });
  }

  onPriceInKeysChange(ev: Event): void {
    const v = parseFloat((ev.target as HTMLInputElement).value);
    this.priceInKeys.set(isFinite(v) ? v : 0);
  }

  onMarkupChange(ev: Event): void {
    const v = parseFloat((ev.target as HTMLInputElement).value);
    this.markupPercent.set(isFinite(v) ? v : 0);
  }

  onKeyPriceChange(ev: Event): void {
    const v = parseFloat((ev.target as HTMLInputElement).value);
    this.keyPrice.set(isFinite(v) ? v : 0);
  }

  applySuggested(): void {
    this.apply.emit(Number(this.suggestedPrice().toFixed(2)));
  }
}
